'use client';

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { type SubmitHandler, useFormContext } from 'react-hook-form';
import { DialogHeader } from '@packages/modules/src/Dialog/DialogHeader/DialogHeader.client';
import type { ChangeAddressFormData } from '@packages/modules/src/ChangeAddressForm/ChangeAddressForm.client';
import ChangeAddressForm from '@packages/modules/src/ChangeAddressForm/ChangeAddressForm.client';
import type { CustomerAddressWriteable } from '@packages/gql/generated/shopping/graphql';
import { Dialog } from '@packages/shared/src/ui/Dialog/Dialog';
import { DialogContent } from '@packages/shared/src/ui/Dialog/DialogContent/DialogContent';
import { Button } from '@packages/shared/src/ui/Button/Button';

interface AddressEditDialogProps {
  open: boolean;
  onClose: () => void;
  address: CustomerAddressWriteable;
}

const AddressEditDialog: React.FC<AddressEditDialogProps> = ({ open, onClose, address }) => {
  const { setValue } = useFormContext();

  const moveValuesToParentFormState: SubmitHandler<ChangeAddressFormData> = (data) => {
    setValue('addressForm.gender', data.gender);
    setValue('addressForm.firstName', data.firstName);
    setValue('addressForm.lastName', data.lastName);
    setValue('addressForm.street', data.street);
    setValue('addressForm.houseNumber', data.houseNumber);
    setValue('addressForm.zipCode', data.zipCode);
    setValue('addressForm.city', data.city);
    onClose();
  };

  return (
    <Dialog isOpen={open} onClose={onClose}>
      <DialogHeader onClose={onClose}>
        <FormattedMessage id="AddressEditDialog.title" defaultMessage="Daten ändern" />
      </DialogHeader>
      <DialogContent className="p-0">
        <div className="p-2 text-center">
          <FormattedMessage
            id="AddressEditDialog.desc"
            defaultMessage="Falls die von uns angegebenen Daten nicht passen,
kannst du sie hier schnell & einfach ändern"
          />
        </div>
        <div className="bg-color-grey-light p-2">
          <ChangeAddressForm
            address={address}
            submitHandler={moveValuesToParentFormState}
            markFieldsMandatory={false}
            inlineErrors={null}
          >
            {(isSubmitting) => (
              <div className="flex w-full flex-col gap-2 p-2">
                <Button
                  variant="color-button"
                  color="primary"
                  type="submit"
                  disabled={isSubmitting}
                >
                  <FormattedMessage
                    id="ChangeAddressDialog.submit"
                    defaultMessage="Änderung übernehmen"
                  />
                </Button>
                <Button variant="color-button" onClick={onClose}>
                  <FormattedMessage id="ChangeAddressDialog.cancel" defaultMessage="Abbrechen" />
                </Button>
              </div>
            )}
          </ChangeAddressForm>
        </div>
      </DialogContent>
    </Dialog>
  );
};

// eslint-disable-next-line import-x/no-default-export
export default AddressEditDialog;
